import { fetchStockIssueCategoryDetail } from '#/api/system/stockIssueCategory/fetchDetail';
import { fetchStockIssueCategoryList } from '#/api/system/stockIssueCategory/fetchList';
import { coerceFilterValues } from '#/modules/commonComponents/table/columnFilterUtils';

export function mapStockIssueCategoryRowsToSelectOptions(rows = []) {
  return rows.map((row) => ({
    value: row.id,
    label: [row.code, row.name].filter(Boolean).join(' ') || String(row.id),
  }));
}

/**
 * ACTIVE 出庫類別 select options（出庫單 Create 等）。
 * 使用 lookupQueryKey('stockIssueCategorySelect')。
 */
export async function fetchStockIssueCategorySelectOptions() {
  const { data } = await fetchStockIssueCategoryList({
    page: 1,
    pageSize: 200,
    keyword: '',
    sort: [],
    filters: { status: 'ACTIVE' },
  });

  return mapStockIssueCategoryRowsToSelectOptions(data ?? []);
}

/** 列表表頭 async multi filter：搜尋 ACTIVE 出庫類別 */
export async function searchStockIssueCategoryFilterOptions({ keyword }) {
  const result = await fetchStockIssueCategoryList({
    page: 1,
    pageSize: 20,
    keyword: keyword ?? '',
    sort: [],
    filters: { status: 'ACTIVE' },
  });

  return mapStockIssueCategoryRowsToSelectOptions(result.data ?? []);
}

/**
 * URL 已有 stockIssueCategoryId 但 label cache 空時，依 id 補 `code name`。
 * @returns {Promise<boolean>} 是否有寫入新 label（供觸發 re-render）
 */
export async function hydrateStockIssueCategoryFilterLabels(ids, labelCache) {
  if (!labelCache) {
    return false;
  }

  const missing = coerceFilterValues(ids).filter((id) => !labelCache.has(String(id)));
  if (missing.length === 0) {
    return false;
  }

  await Promise.all(missing.map(async (id) => {
    try {
      const result = await fetchStockIssueCategoryDetail(id);
      const row = result?.data;
      if (!row) {
        return;
      }

      const label = [row.code, row.name].filter(Boolean).join(' ') || String(id);
      labelCache.set(String(id), label);
    } catch {
      // 留下 unresolved；ListFilterStatus 會顯示「已選 N 項」
    }
  }));

  return missing.some((id) => labelCache.has(String(id)));
}
